import { Text } from 'recharts';

interface CustomYAxisTickProps {
  x?: number;
  y?: number;
  payload?: { value: string };
  /** Width available for the tick label — passed from YAxis. */
  width?: number;
}

/**
 * Custom YAxis tick that wraps long labels instead of truncating them
 * (TELV1-419 — shared by ArtifactChartBlock and ArtifactGroupedChartBlock).
 * Uses Recharts' own `<Text>` component which handles multi-line SVG text
 * natively via `width` + `verticalAnchor`.
 */
function WrappedYAxisTick({ x = 0, y = 0, payload, width = 120 }: CustomYAxisTickProps) {
  if (!payload?.value) return null;
  return (
    <Text
      x={x}
      y={y}
      width={width}
      textAnchor="end"
      verticalAnchor="middle"
      fontSize={11}
      fill="#525252"
      lineHeight="1.3em"
      style={{ fontFamily: 'Inter, sans-serif' }}
    >
      {payload.value}
    </Text>
  );
}

export default WrappedYAxisTick;
